import React, { FC } from 'react';
import cx from 'classnames';
import { makeStyles, Theme } from '@material-ui/core';
import { ReactComponent as CrossIcon } from 'img/icons/times.svg';
import { ReactComponent as CheckIcon } from 'img/icons/check.svg';

const useStyles = makeStyles((theme: Theme) => ({
  statusIcon: {
    width: '1rem',
    height: '1rem',
    marginRight: theme.spacing(0.5),

    '&.primary': {
      color: theme.palette.primary.main,
    },
    '&.error': {
      color: theme.palette.error.main,
    },
  },
}));

type ICheckCrossIcon = {
  value: boolean;
};

const CheckCrossIcon: FC<ICheckCrossIcon> = ({ value }) => {
  const classes = useStyles();

  return value ? (
    <CheckIcon className={cx(classes.statusIcon, 'primary')} />
  ) : (
    <CrossIcon className={cx(classes.statusIcon, 'error')} />
  );
};

export default CheckCrossIcon;
